<template>
  <div class="charge-preview">
    <BfTitle class="mb-3" size="small">{{title}}</BfTitle>

    <b-row>
      <b-col
        v-for="(previewColumn, index) in previewColumnsData"
        :key="index"
        cols="12"
        class="charge-preview-column"
      >
        <div
          v-for="({label, value}, index) in previewColumn"
          :key="`${label}_${index}`"
          class="preview-data-row"
        >
          <div class="row-key" :title="label">{{label}}</div>
          <div class="row-value" :title="value">{{value}}</div>
        </div>
      </b-col>
    </b-row>

    <div v-if="showViewMore" class="text-center mt-4">
      <BfButton
        tag="router-link"
        :to="viewMorePath"
      >
        Ver encargo
      </BfButton>
       <BfButton
        tag="router-link"
        :to="viewIncidenciasPath"
        class='btn-ver-incidencias'
      >
        Ver Incidencias
      </BfButton>
    </div>

  </div>
</template>

<script>
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';

export default {
  name: 'ChargeSidePreview',

  props: {
    chargeData: {
      type: Object,
      default: () => {},
    },

    showViewMore: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    title() {
      const number = get(this.chargeData, ['numero_encargo'], '');

      return `Encargo ${number}`;
    },

    viewMorePath() {
      const id = get(this.chargeData, ['id'], '');
      return { name: 'charge', params: { id } };
    },
    viewIncidenciasPath() {
      const number = get(this.chargeData, ['numero_encargo'], '');

      return `/incidencias?textSearch=${number}`;
    },

    previewColumnsData() {
      if (isEmpty(this.chargeData)) {
        return [];
      }


      return [
        [
          {
            label: 'Código',
            value: get(this.chargeData, ['codigo'], '-'),
          },
          {
            label: 'Nº Encargo',
            value: get(this.chargeData, ['numero_encargo'], '-'),
          },
          {
            label: 'Sucursal',
            value: get(this.chargeData.sucursal, ['nombre'], '-'),
          },
          {
            label: 'Solicitante',
            value: get(this.chargeData, ['solicitante_nombre'], '-'),
          },
          {
            label: 'Dirección',
            value: get(this.chargeData, ['inmueble_direccion']) ? get(this.chargeData, ['inmueble_direccion']) : '-',
          },
          {
            label: 'Código Postal',
            value: get(this.chargeData, ['inmueble_codigopostal']) ? get(this.chargeData, ['inmueble_codigopostal']) : '-',
          },
          {
            label: 'Población',
            value: get(this.chargeData, ['inmueble_poblacion']) ? `${get(this.chargeData, ['inmueble_poblacion'])} (${get(this.chargeData, ['inmueble_provincia'])})` : '-',
          },
        ],
        [
          {
            label: 'Contacto 1',
            value: get(this.chargeData, ['contacto_persona1']) ? get(this.chargeData, ['contacto_persona1']) : '-',
          },
          {
            label: 'Teléfono 1',
            value: get(this.chargeData, ['contacto_telefono1']) ? get(this.chargeData, ['contacto_telefono1']) : '-',
          },
          {
            label: 'Contacto 2',
            value: get(this.chargeData, ['contacto_persona2']) ? get(this.chargeData, ['contacto_persona2']) : '-',
          },
          {
            label: 'Teléfono 2',
            value: get(this.chargeData, ['contacto_telefono2']) ? get(this.chargeData, ['contacto_telefono2']) : '-',
          },

          {
            label: 'Fecha de Visita ',
            value: get(this.chargeData, ['visita_formateada']) ? get(this.chargeData, ['visita_formateada']) : '-',
          },
          {
            label: 'Fecha de Envio ',
            value: get(this.chargeData, ['estado_terminado_formateado']) ? get(this.chargeData, ['estado_terminado_formateado']) : '-',
          },
          {
            label: 'Fecha de Visado',
            value: get(this.chargeData, ['fecha_visado_formateado']) ? get(this.chargeData, ['fecha_visado_formateado']) : '-',
          },
          {
            label: 'Fecha de Facturación ',
            value: get(this.chargeData, ['fecha_facturacion_formateada']) ? get(this.chargeData, ['fecha_facturacion_formateada']) : '-',
          },
        ],
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.charge-preview {
  border: 3px solid #000;
  padding: 16px;
}

.charge-preview-column {
  .preview-data-row {
    display: flex;
    font-size: 14px;

    .row-key,
    .row-value {
      padding-bottom: 8px;
      flex: 1 0 50%;
      max-width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .row-key {
      position: relative;
      padding-right: 16px;

      &::after {
        content: '';
        width: 1px;
        height: 100%;
        background: #000;
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .row-value {
      font-weight: bold;
      padding-left: 16px;
    }
  }
}
.btn-ver-incidencias{
  margin-left: 0.5em;
}
</style>
